import type { ConversationTurn } from '@/types/message';
import MarkdownRenderer from '@/components/common/MarkdownRenderer';
import { formatMessageTime } from '@/utils/formatDate';

interface MessageBubbleProps {
  turn: ConversationTurn;
}

export default function MessageBubble({ turn }: MessageBubbleProps) {
  const isUser = turn.role === 'user';

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`
          max-w-[80%] px-4 py-2.5
          ${
            isUser
              ? 'rounded-2xl rounded-br-sm bg-gradient-to-br from-primary-800 to-primary-700 border border-primary-400/20 shadow-md shadow-black/40 text-primary-10'
              : 'rounded-2xl rounded-bl-sm bg-gradient-to-br from-neutral-200 to-neutral-300 border border-neutral-400/15 shadow-md shadow-black/40 text-neutral-900'
          }
        `}
      >
        {isUser ? (
          <p className="text-sm whitespace-pre-wrap">{turn.content}</p>
        ) : (
          <MarkdownRenderer content={turn.content} />
        )}
        <p
          className={`mt-1 text-xs ${
            isUser ? 'text-primary-200' : 'text-neutral-400'
          }`}
        >
          {formatMessageTime(turn.timestamp)}
        </p>
      </div>
    </div>
  );
}
